// extracted by mini-css-extract-plugin
module.exports = {"empty_data":"EmptyData_empty_data___Y0xB","text":"EmptyData_text__QUt2N","small":"EmptyData_small__Hr_Fr","medium":"EmptyData_medium__5OEEY"};